;(() => {
  function debounce(func, timeout = 10) {
    let timer
    return (...args) => {
      clearTimeout(timer)
      timer = setTimeout(() => {
        func.apply(this, args)
      }, timeout)
    }
  }

  const container = document.querySelector('.sticky-add-to-cart')
  const originalButton = document.querySelector('.add-to-cart-button')

  if (!container || !originalButton) {
    return
  }

  const handleDisplay = () => {
    const buttonRect = originalButton.getBoundingClientRect()
    const buttonBottom = buttonRect.top + buttonRect.height
    if (100 >= buttonBottom && container.classList.contains('d-none')) {
      container.classList.remove('d-none')
    } else if (100 < buttonBottom && !container.classList.contains('d-none')) {
      container.classList.add('d-none')
    }
  }

  window.addEventListener('scroll', debounce(handleDisplay))
  window.addEventListener('load', handleDisplay)
})()
